import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Inject,
  OnInit,
} from '@angular/core';

import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import {
  FuseMediaWatcherService,
  FuseNavigationService,
  FuseVerticalNavigationComponent,
} from '@fleet/fuse';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

import { FleetNavigationService } from '@fleet/navigation';

import { FuseNavigationItem } from '@fleet/fuse/lib/components';

import { ProductConfigurationService } from '@fleet/product-configuration';
// import { AuthService } from '@fleet/auth/services/auth.service';
import { TravellerModel } from '@fleet/model';

@Component({
  selector: 'fleet-traveller-layout',
  templateUrl: './fleet-traveller-layout.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FleetTravellerLayoutComponent implements OnInit {
  private _unsubscribeAll: Subject<any> = new Subject<any>();
  fleetProduct: string;
  isScreenSmall: boolean;
  monoLogoSrc: string;
  navigation: FuseNavigationItem[];
  logoSrc: string;
  user: TravellerModel;
  showNewJobButton: boolean;
  /**
   * Constructor
   */
  constructor(
    private _fuseMediaWatcherService: FuseMediaWatcherService,
    private _activatedRoute: ActivatedRoute,
    private _router: Router,
    // private authService: AuthService,
    private _fuseNavigationService: FuseNavigationService,
    private fleetNavigationService: FleetNavigationService,
    private changeDetectorRef: ChangeDetectorRef,
    private _productConfigurationService: ProductConfigurationService,

    @Inject('env') env: any
  ) {
    this.fleetProduct = env.fleetProduct;
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Accessors
  // -----------------------------------------------------------------------------------------------------

  /**
   * Getter for current year
   */
  get currentYear(): number {
    return new Date().getFullYear();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {
    this._router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        takeUntil(this._unsubscribeAll)
      )
      .subscribe((event: any) => {
        this.showNewJobButton =
          !event.url.includes('job/new') && event.url.includes('guest')
            ? true
            : false;
        this.changeDetectorRef.markForCheck();
      });

    // this.authService.user$.pipe(takeUntil(this._unsubscribeAll)).subscribe({
    //   next: (user: any) => {
    //     this.user = user;
    //     this.changeDetectorRef.markForCheck();
    //   },
    // });
    // Subscribe to navigation data
    this._fuseMediaWatcherService.onMediaChange$
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe(({ matchingAliases }) => {
        // Check if the screen is small
        this.isScreenSmall = !matchingAliases.includes('md');
        this.changeDetectorRef.markForCheck();
      });

    this.fleetNavigationService.navigation$
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe({
        next: (navigation: FuseNavigationItem[]) => {
          //its grouped so flatter
          if (navigation && navigation.length > 0) {
            this.navigation = navigation[0].children;
            this.changeDetectorRef.markForCheck();
          }
        },
      });

    this._productConfigurationService.config$
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe({
        next: (config: any) => {
          if (config.horizontalLogo) {
            this.logoSrc = config.horizontalLogo;
            this.monoLogoSrc = config.horizontalMonoLogo;
            this.changeDetectorRef.markForCheck();
          }
        },
      });
  }

  /**
   * On destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }

  routeToNewJob() {
    if (this.user) {
      this._router.navigate(['traveller/job/new']);
    } else {
      this._router.navigate(['guest/job/new']);
    }
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Toggle navigation
   *
   * @param name
   */
  toggleNavigation(name: string): void {
    // Get the navigation
    const navigation =
      this._fuseNavigationService.getComponent<FuseVerticalNavigationComponent>(
        name
      );

    if (navigation) {
      // Toggle the opened status
      navigation.toggle();
    }
  }
}
